import { render, staticRenderFns } from "./toast-notification-component.vue?vue&type=template&id=1ca083af&scoped=true&"
import script from "./toast-notification-component.vue?vue&type=script&lang=ts&"
export * from "./toast-notification-component.vue?vue&type=script&lang=ts&"
import style0 from "./toast-notification-component.vue?vue&type=style&index=0&id=1ca083af&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca083af",
  null
  
)

export default component.exports